export const SAVE = 'modules/book/SAVE';
export const SELECT = 'modules/book/SELECT';

